// ========================================
// 📄 src/components/interactions/InteractionForm.jsx
// ========================================
import React, { useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { useNotification } from "../../contexts/NotificationContext";
import { INTERACTION_TYPES, SENTIMENT_OPTIONS } from "../../config/constants";
import { interactionService } from "../../services/interactionService";

const InteractionForm = ({ leadId, onCreated, onCancel }) => {
  const { currentUser } = useAuth();
  const { showSuccess, showError } = useNotification();

  const [form, setForm] = useState({
    type: INTERACTION_TYPES[0],
    sentiment: SENTIMENT_OPTIONS[2],
    notes: "",
  });
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!leadId || !currentUser) return;

    setSubmitting(true);
    try {
      const res = await interactionService.createInteraction(
        leadId,
        currentUser.uid,
        form
      );
      if (res.success) {
        showSuccess("Interaction ajoutée", "Votre interaction a été enregistrée.");
        setForm({ type: INTERACTION_TYPES[0], sentiment: SENTIMENT_OPTIONS[2], notes: "" });
        if (typeof onCreated === "function") onCreated(res.id);
      } else {
        showError("Échec", res.error || "Impossible d'ajouter l'interaction");
      }
    } catch (err) {
      showError("Erreur", err.message || String(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Type</label>
          <select
            name="type"
            value={form.type}
            onChange={handleChange}
            className="w-full border rounded-lg px-3 py-2"
          >
            {INTERACTION_TYPES.map((t) => (
              <option key={t} value={t}>
                {t}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Sentiment</label>
          <select
            name="sentiment"
            value={form.sentiment}
            onChange={handleChange}
            className="w-full border rounded-lg px-3 py-2"
          >
            {SENTIMENT_OPTIONS.map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Notes</label>
        <textarea
          name="notes"
          value={form.notes}
          onChange={handleChange}
          rows={4}
          className="w-full border rounded-lg px-3 py-2"
          placeholder="Résumé de l'échange, points importants, next steps..."
        />
      </div>

      <div className="flex items-center gap-3">
        <button
          type="submit"
          disabled={submitting}
          className="btn-primary disabled:opacity-50"
        >
          {submitting ? "Enregistrement..." : "Ajouter"}
        </button>
        {onCancel && (
          <button
            type="button"
            onClick={onCancel}
            className="btn-secondary"
          >
            Annuler
          </button>
        )}
      </div>
    </form>
  );
};

export default InteractionForm;
